import { Link as CapraLink, Pill } from '@capra/core';
import { Button } from 'antd';
import NextLink from 'next/link';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 40px 1fr;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    'header header'
    'sidebar content';
  height: 100vh;
  width: 100%;
`;

export const ContextWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: var(--cds-spacing-md);
  height: 16px;
`;

export const LogoLink = styled(CapraLink).attrs({ as: NextLink })`
  display: flex;
`;

export const Header = styled.header`
  background-color: rgba(245, 245, 245, 1);
  color: rgba(0, 0, 0, 0.45);
  height: 40px;
  display: flex;
  grid-area: header;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 10;
`;

export const NonProductionTag = styled(Pill)`
  border-radius: 4px;
  color: #333;
  padding: 0 16px;
`;

export const GoEnterpriseButton = styled(Button)`
  margin: 0px 2px;
  padding: 0px 20px;
  &.ant-btn {
    height: unset;
  }
`;

export const SideBar = styled.div`
  background-color: rgba(245, 245, 245, 1);
  border-right: 1px solid #f0f0f0;
  grid-area: sidebar;
  justify-self: stretch;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  /* ensure nav fills height */
  & > * {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* icon color fix */
  svg {
    flex-shrink: 0;
    fill: currentColor;
    width: 16px;
    height: 16px;

    path {
      fill: currentColor;
    }
  }

  /* styling for the anchor tags to match the nav palette on hover */
  a:hover,
  a:focus-visible {
    color: inherit;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: content;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: none;
  border-right: none;
  overflow: hidden;
  
  --main-layout-horizontal-padding: 16px;
  --main-layout-top-padding: 16px;
  --main-layout-bottom-padding: 64px;
`;

export const ContentHeader = styled.header`
  background: #FFFFFF;
  padding: var(--main-layout-top-padding, 16px) var(--main-layout-horizontal-padding, 16px) 0 var(--main-layout-horizontal-padding, 16px);
`;

export const Main = styled.main`
  flex-grow: 1;
  overflow: auto;
  padding: 0 var(--main-layout-horizontal-padding, 16px) var(--main-layout-bottom-padding, 64px) var(--main-layout-horizontal-padding, 16px);
  margin-top: 8px;
`;

export const ProductDropdownWraper = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 4px 0;
  width: 80px;
  gap: 4px;
  svg {
    fill: rgba(0, 0, 0, 0.45);
  }
  &:hover {
    span {
      color: rgba(0, 0, 0, 0.85);
    }
    svg {
      fill: rgba(0, 0, 0, 0.85);
    }
  }
`;

export const ProductSelector = styled.div`
  display: flex;
  cursor: pointer;
  border-radius: 2px;
  &:hover {
    background: #ced9e0;
  }
`;
